"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const lang_1 = require("../../../lib/lang");
if (process.env.BROWSER) {
    require('./index.less');
}
function Report(props) {
    if (!props.url) {
        return null;
    }
    return React.createElement("a", { className: 'report', href: props.url }, lang_1.__('widgetReport.text'));
}
exports.Report = Report;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJpbmRleC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSwrQkFBZ0M7QUFDaEMsNENBQXVDO0FBQ3ZDLElBQUksT0FBTyxDQUFDLEdBQUcsQ0FBQyxPQUFPLEVBQUU7SUFDckIsT0FBTyxDQUFDLGNBQWMsQ0FBQyxDQUFDO0NBQzFCO0FBQ0YsU0FBZ0IsTUFBTSxDQUFDLEtBQXVCO0lBQzFDLElBQUksQ0FBQyxLQUFLLENBQUMsR0FBRyxFQUFFO1FBQ1osT0FBTyxJQUFJLENBQUM7S0FDZjtJQUNELE9BQU8sMkJBQUcsU0FBUyxFQUFFLFFBQVEsRUFBRSxJQUFJLEVBQUUsS0FBSyxDQUFDLEdBQUcsSUFBRyxTQUFFLENBQUMsbUJBQW1CLENBQUMsQ0FBSyxDQUFDO0FBQ2xGLENBQUM7QUFMRCx3QkFLQyJ9